<template>
<div>
    <v-dialog light persistent v-model="settings" class="cardUp">
        <v-layout align-center column justify-center class="cardStats" style="height:100%">
            <table style="width: 100%" class="mb-3">
                <tr>
                    <td width="100%" class="cardStatsHeader  pa-1" colspan=2>
                       Configurazione
                    </td>
                </tr>
                <tr>
                    <td width="100%" class="  pa-1" colspan=2>
                        <v-text-field style="color: white; background-color: white" v-model="operatore" label="Nome operatore" outline clearable @input="changedOperatore"></v-text-field>
                    </td>
                </tr>
                <tr>
                    <td width="100%" class=" pa-1" colspan=2>
                        <v-text-field style="   color: white; background-color: white" v-model="vascheInput" label="Vasche " outline clearable @input="changedVasche"></v-text-field>
                    </td>
                </tr>
                <tr>
                    <td width="100%" class="  pa-1" colspan=2>
                        <v-btn round class="success white--text" @click="setStart()">START</v-btn>
                        <v-spacer></v-spacer>
                         <v-btn round class="success white--text" @click="resetStart()">RESET</v-btn>
                    </td>
                </tr>
            </table>
            <v-btn round class="black  white--text" @click="settings=false">Chiudi</v-btn>
        </v-layout>
    </v-dialog>

    <v-toolbar app color="black" dark>
        <v-toolbar-title data-cy="titleBtn">
            <img class="menuLogo ml-0 mt-2" src="../assets/images/Logo.png" style="height: 45px" @click="gotoHome()" />
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-layout v-if="isDesktopMode()" align-start row justify-center class="red darken-2 p-0 m-0" style="border-radius: 10px 10px 10px 10px"><span class="white--text"><strong>{{ nomeGara }}</strong> | Live results
            </span>
        </v-layout>
        <v-spacer></v-spacer>
        <span class="mr-4">
            <v-icon @click="settings =true">timer</v-icon>
        </span>

    </v-toolbar>

    <v-layout align-start row wrap justify-center class="mt-3">
        <v-flex flex xs12 sm12 md12 lg12 style="border-radius: 10px 10px 10px 10px" class="red darken-4 white--text pa-3 ml-2 mr-2 mt-0 mb-3 text-center">
            <v-layout align-center justify-center class="p-0 m-0"><span class="display-1  white--text"><strong>{{ tempo }} </strong>
                </span>
            </v-layout>
             <v-layout v-if="start !== '00:00:00.000'" align-center justify-center class="p-0 m-0"><span class="white--text">Start - <strong>{{ start }} </strong>
                </span>
            </v-layout>
            <!--v-layout v-else align-center justify-center class="p-0 m-0"><span class="white--text">Orario - <strong>{{ clock }} </strong>
                </span>
            </v-layout-->
        </v-flex>
        <v-flex @click="setTime(n)" flex xs12 sm12 md5 lg5 v-for="n in vasche" :key="n" style="border-radius: 10px 10px 10px 10px" class="blue darken-2 white--text pa-0 ma-2 text-center">
            <v-layout align-center justify-center class="p-0 m-0">
                  <table style="color: black; width: 100%" class="mb-3">
                        <tr>
                            <td width="20%" class="pa-1" align="center" >
                                <span class="white--text ml-2">Corsia</span>
                            </td>
                            <td width="60%" class=" pa-1 " align="center" >
                                <span class="white--text ">Tempi</span>
                            </td>
                            <td width="20%" class=" pa-1 " align="right" >
                                <span class="white--text mr-2">Passaggi</span>
                            </td>
                        </tr>
                        <tr>
                            <td width="20%" class="pa-1" align="center" >
                                <span class="display-1  white--text ml-2"><strong>{{ n }} </strong> </span>
                            </td>
                            <td width="60%" class=" pa-2 " align="center">
                                <span class="pa-1 ma-2 display-1  white--text boxed"><strong>{{ mappaIntermedi[n]['lastLap'] }} </strong> </span><br><br>
                                <span class="pa-1 ma-2  display-1  white--text boxed"><strong>{{ mappaIntermedi[n]['tempo'] }} </strong> </span>
                            </td>
                            <td width="20%" class=" pa-1 white--text " align="right" >
                                <span class="display-1  white--text mr-2"><strong>{{ mappaIntermedi[n]['vasche'] }} </strong> </span>
                            </td>
                        </tr>
                  </table>
            </v-layout>
        </v-flex>
    </v-layout>
    <v-footer fixed class="grey darken-2" style="height: 30px; padding: 10px">
        <v-layout align-start row wrap justify-center class="red darken-2 p-0 m-0" style="border-radius: 10px 10px 10px 10px"><span class="white--text"><strong>{{ timer }}</strong> | Postazioni {{ vasche }}
            </span>
        </v-layout>
    </v-footer>
</div>
</template>

<script>
import helper from '../helper';
import dayjs from 'dayjs'

export default {
    components: {
        //      live: LiveRanking,
    },
    name: 'Live',

    data() {
        return {
            items: [],
            itemsF: [],

            raceID: null,
            nomeGara: '',

            configEvento: {},
            elencoIscritti: [],
            tagFile: null,

            myInterval: null,
            sport: '',

            chipMap: {},
            mappaIntermedi: {},
            mappaOrari: {},

            currentIndex: 1,
            listaIntermedi: [],

            stats: false,
            loaded: false,
            dettaglio: false,
            currentItem: {},

            value: 0,
            bufferValue: 100,
            interval: 0,

            multiDivisione: false,
            mappaDivisioni: {},
            listaDivisioni: [],

            mappaFiles: {},
            clockBatterie: {},

            timer: "-",
            vasche: [],
            clock: "",
            tempo: "00:00:00.000",
            settings: false,

            operatore: "Generico",
            vascheInput: "1 2 3 4 5 6",

            start: "00:00:00.000"

        };
    },

    beforeCreate() {},

    created() {},

    beforeDestroy() {
        clearInterval(this.myInterval);
    },

    mounted() {
        //console.log(this.$route.params.sport);
        console.log(this.$route.params.raceID);
        this.raceID = this.$route.params.raceID;
        this.paramID = this.$route.params.id;

        this.local = this.$route.params.local;

        var pref = helper.ls.get('SWIM_TIMER');
        if (pref == undefined) {
            pref = "Generico"
        }

        this.timer = pref;

        if ( helper.ls.get('SWIM_START_'+this.raceID+"_"+this.paramID) !== undefined) {
            this.start = helper.ls.get('SWIM_START_'+this.raceID+"_"+this.paramID);
        }

        //prompt("Nome timer: " + pref);

        var vas = helper.ls.get('SWIM_POOL');
        if (vas == undefined) {
            vas = "1 2 3 4 5 6";
            helper.ls.set('SWIM_POOL', vas);
        }
        this.vasche = vas.split(" ");

        this.vasche.forEach(elem => {
            this.mappaIntermedi[elem] = {
                vasche: 0,
                clock: null,
                lastLap: null,
                tempo: null
            };
        })

        clearInterval(this.myInterval);

        //this.refresh(this);
        let refreshTime = 100;
        this.myInterval = setInterval(this.refresh, refreshTime, this);

    },

    methods: {

        setStart(){
            this.start = this.getTS();
            helper.ls.set('SWIM_START_'+this.raceID+"_"+this.paramID, this.start);

            let _url = this.getTagsURL() + "writeFileTag?idGara=" + this.raceID + "&id=" + this.paramID + "&tag=TGPOOL"+this.paramID+"_START" + "&ts=" + this.start+"&op="+this.timer;
            console.log("EXECUTE:" + _url);
            this.writeTag(_url).then( response => {
                console.log(response)
            });


        },

        resetStart(){
            this.start = "00:00:00.000";
            this.tempo = "00:00:00.000"
            helper.ls.set('SWIM_START_'+this.raceID+"_"+this.paramID, this.start);
        },

        changedOperatore() {
            if (this.operatore !== undefined && this.operatore !== '') this.timer = this.operatore;
            helper.ls.set('SWIM_TIMER', this.timer);
        },

        changedVasche() {
            if (this.vascheInput !== undefined || this.vascheInput !== '') {
                this.vasche = this.vascheInput.split(" ");
                helper.ls.set('SWIM_POOL', this.vascheInput);
            }
        },

        setTime(corsia) {
            if ( this.start == '00:00:00.000') {
                alert("Cronometro non attivo")
                return;
            }
            //console.log("Corsia:" + corsia);
            let now = this.getTS();
            this.mappaIntermedi[corsia]['vasche'] = this.mappaIntermedi[corsia]['vasche'] + 1;
            if (this.mappaIntermedi[corsia]['clock'] != null) {
                this.mappaIntermedi[corsia]['clock-1'] = this.mappaIntermedi[corsia]['clock'];
                let diff = this.diffTime(now, this.mappaIntermedi[corsia]['clock-1']);
                this.mappaIntermedi[corsia]['lastLap'] = diff;
               
            }
            this.mappaIntermedi[corsia]['clock'] = now;
            let tempo = this.diffTime(now, this.start);
            this.mappaIntermedi[corsia]['tempo'] = tempo;
            if ( this.mappaIntermedi[corsia]['lastLap'] === null) {
                this.mappaIntermedi[corsia]['lastLap'] = tempo;
            }

            let _url = this.getTagsURL() + "writeFileTag?idGara=" + this.raceID + "&id=" + this.paramID + "&tag=TGPOOL"+this.paramID+"_" + corsia+ "&ts=" + now+"&op="+this.timer;
            console.log("EXECUTE:" + _url);
            this.writeTag(_url).then( response => {
                console.log(response)
            });


        },

        refresh: function (self) {
            self.clock = self.getTS();
            if ( this.start !== '00:00:00.000' )
                self.tempo = this.diffTime(self.clock, this.start);
            //self.execute(self);
        },

        getTS() {
            return dayjs(new Date()).format('HH:mm:ss.SSS');
        },

        execute(self) {
            let startFrom = this.mappaFiles[self.currentIndex];
            if (startFrom == undefined) {
                this.mappaFiles[self.currentIndex] = 0;
                startFrom = 0;
            }

            let _url = this.getTagsURL() + "?indexFrom=" + startFrom + "&idGara=" + this.raceID + "&id=" + this.paramID + "&ref=" + this.currentIndex;
            if (this.local) {
                //    _url = self.configEvento['baseUrl']+ this.raceID+ "/" + self.configEvento['tagFile' + self.currentIndex] + "?date=" + this.getTS();
            }
            console.log("EXECUTE:" + _url);
            self.getRemoteService(_url).then(
                (response) => {
                    if (response.length > 0) {
                        response = "tag;clock;antenna;progr\n" + response;
                        this.popolaPassaggi(response);
                    }

                    if (self.currentIndex < (self.configEvento.numImtermedi)) {
                        self.currentIndex++;
                        self.execute(self);
                    } else {
                        this.loaded = true;
                        this.showClassifica(self);
                    }
                }
            ).catch(
                (error) => {
                    console.log("Errore " + error);
                    self.mappaIntermedi[self.currentIndex] += 0;
                    if (self.currentIndex < (self.configEvento.numImtermedi)) {
                        self.currentIndex++;
                        self.execute(self);
                    } else {
                        self.loaded = true;
                        self.showClassifica(self);
                    }
                });

        },

        compareRil(a, b, index) {
            if (a.rilevamenti[index].length === b.rilevamenti[index].length) {
                if (a.rilevamenti[index].length == 0) return 0;
                //const tempoA = a.rilevamenti[index][a.rilevamenti[index].length - 1].time;
                //const tempoB = b.rilevamenti[index][b.rilevamenti[index].length - 1].time;

                const tempoA = a['tempo' + index];
                const tempoB = b['tempo' + index];
                //console.log("COMPARE:" +  a.rilevamenti[index].length + " - " + b.rilevamenti[index].length +" - " + tempoA + " " + tempoB);

                if (tempoA === undefined && tempoB == undefined) return 0;
                else if (tempoA === undefined) {
                    return -1
                } else if (tempoB === undefined) {
                    return 1
                }

                if (tempoA < tempoB) {
                    return -1;
                }
                if (tempoA > tempoB) {
                    return 1;
                }
                return 0;
            } else {
                return (b.rilevamenti[index].length - a.rilevamenti[index].length)
            }
        },

        compare(a, b) {

            for (let index = (this.configEvento.numImtermedi); index > 0; index--) {
                let res = this.compareRil(a, b, index);
                if (res != 0) return res;
            }
        },

        showClassifica(self) {
            let posM = 1;
            let posF = 1;

            let clockPrimo = null;
            let clockUltimo = null;

            this.elencoIscritti.sort(this.compare);
            this.elencoIscritti.forEach(elem => {
                if (elem.sesso === 'F') {
                    elem.posAss = posF++;
                } else {
                    elem.posAss = posM++;
                }

                if (clockPrimo == null) {
                    elem.distacco1 = "";
                    elem.distacco2 = "";
                    clockPrimo = elem.tempo;
                } else {
                    if (elem.tempo > clockPrimo) {
                        elem.distacco1 = this.diffTime(elem.tempo, clockPrimo);
                    } else {
                        elem.distacco1 = "-";
                    }
                    if (elem.tempo >= clockUltimo) {
                        elem.distacco2 = this.diffTime(elem.tempo, clockUltimo);
                    } else {
                        elem.distacco2 = "-";
                    }
                }
                clockUltimo = elem.tempo;

                //console.log("Tempo:" + elem.tempo +">"+ clockPrimo);

            });

            self.items = this.elencoIscritti;
            self.itemsF = this.filteredList();

        },

        isRilevamentoValido(listaRilevamentiAtleta, clock, idPassaggio, laps) {
            //console.log("VALUTO VALIDITA':" + this.configEvento['numLap' + idPassaggio]+ " " + listaRilevamentiAtleta.length);
            if (listaRilevamentiAtleta.length == 0) return true;

            if (listaRilevamentiAtleta.length < laps) {
                let valTime = 0;
                if (this.configEvento['valTime' + idPassaggio] !== undefined) {
                    valTime = parseInt(this.configEvento['valTime' + idPassaggio]) * 1000;
                }
                let ultimoPassaggio = this.getTime(listaRilevamentiAtleta[listaRilevamentiAtleta.length - 1].clock);
                //if (ultimoPassaggio.indexOf(".") == -1) ultimoPassaggio += ".000";

                const t0 = dayjs("1970-01-01 " + ultimoPassaggio).utc();
                const t1 = dayjs("1970-01-01 " + this.getTime(clock)).utc();

                //console.log(tempoOrig);
                const diff = t1.valueOf() - t0.valueOf();
                if (diff >= valTime) {
                    return true;
                } else {
                    console.log("Valtime > " + valTime);
                    console.log(ultimoPassaggio + " > " + t0.valueOf());
                    console.log(this.getTime(clock) + " > " + t1.valueOf());
                    console.log("DIFF:" + diff);
                }
            } else {
                console.log("Scarto numLap superiori a quelli ammessi nel passaggio  ");
            }
            return false;
        },

        popolaPassaggi(data) {
            let index = this.currentIndex;
            console.log("popolaPassaggi>" + index);
            //let cutFrom = this.configEvento['cutFrom' + index];
            //if (cutFrom.indexOf(".") == -1) cutFrom += ".000";

            //let syncTime = this.configEvento['syncTime' + index];
            //if (syncTime.indexOf(".") == -1) syncTime += ".000";

            let laps = 1;
            if (this.configEvento['numLap' + index] !== undefined) {
                laps = parseInt(this.configEvento['numLap' + index]);
            }

            //startFrom = 0; // da eliminare

            let lista = this.csvJSON(data);
            console.log("aggiungo >" + lista.length + " letture");
            // console.log("aggiungo >" + JSON.stringify(lista)  );
            this.mappaFiles[index] += lista.length;

            let result = [];

            lista.forEach(elem => {
                if (elem.clock === undefined) {
                    //console.log("Time " + elem.clock + " is before cut: " + cutFrom);
                } else {

                    let p = this.chipMap[elem['tag']];
                    if (p !== undefined) {
                        let pettorale = p['pett'];

                        if (this.isRilevamentoValido(p.rilevamenti[index], elem.clock, index, laps)) {

                            p.rilevamenti[index].push({
                                time: this.getTempo(p.guntime, elem.clock),
                                clock: this.getTime(elem.clock),
                                fraz: this.getTime(elem.clock)
                            });

                            if (p.rilevamenti[index].length == laps) {

                                //if (laps > 1 ) console.log("PASSAGGI CORRETTI:" + p.cognome + " " + p.pett)
                                p.clock = this.getTime(elem.clock);
                                p.tempo = this.getTempo(p.guntime, elem.clock)

                                p['tempo' + index] = this.getTempo(p.guntime, elem.clock);
                                p['clock' + index] = this.getTime(elem.clock);
                                p['fraz' + index] = this.getTime(elem.clock);
                            }

                            result.push(p);
                        } else {
                            console.log("passaggio non valido:" + elem.tag + " " + p.cognome + " " + elem.clock + " >>" + JSON.stringify(p.rilevamenti[index]));
                        }
                    } else {
                        console.log("Tag " + elem.tag + " sconosciuto");
                    }

                }

            })

            this.mappaIntermedi[index] += result.length;
            return result;

        },

        getTime(tempo) {
            let t = tempo.split(".");
            return t[0];
        },

        getIsoDate(aDate) {
            const res = aDate.replace(/-/g, '/').replace('T', ' ');
            //console.log("getIso:" + aDate + " >> " + res);
            return res;
        },

        getTempo(guntime, tempoRil) {
            var utc = require('dayjs/plugin/utc')
            dayjs.extend(utc)
            const tt0 = "1970-01-01 " + guntime;
            const tt1 = "1970-01-01 " + tempoRil;

            //console.log("getTempo: " + tt0+" "+ tt1);

            const t0 = dayjs(this.getIsoDate(tt0)).utc();
            const t1 = dayjs(this.getIsoDate(tt1)).utc();

            var duration = (t1.diff(t0));
            let result = dayjs(duration).utc().format(this.configEvento.timeFormat);

            //console.log(">getTempo: " +result);

            if (result === 'Invalid Date') return tempoRil;

            return result;
        },

        diffTime(tempo1, tempo0) {
            var utc = require('dayjs/plugin/utc')
            dayjs.extend(utc);

            const tt0 = "1970-01-01 " + tempo0;
            const tt1 = "1970-01-01 " + tempo1;

            //console.log("DIFF:" + tt0 + " " + tt1);

            const t0 = dayjs(this.getIsoDate(tt0)).utc();
            const t1 = dayjs(this.getIsoDate(tt1)).utc();

            var duration = (t1.diff(t0));
            let result = dayjs(duration).utc().format('mm:ss.SSS');
            if (result.startsWith("00:"))
                result = result.substring(3, result.length);

            return result;
        },

        gotoHome() {
            this.$router.push('/');
        },

        isMobileMode: function () {
            let res = this.$vuetify.breakpoint.name === 'xs';
            return res;
        },
        isDesktopMode: function () {
            return !this.isMobileMode();
        },

        toggleCompatta() {
            this.compatta = !this.compatta;
        },
        togglePreferiti() {
            this.filterPreferiti = !this.filterPreferiti;
            this.showClassifica(this.raceData);
        },
        toggleItem(pett) {
            if (this.listaPreferiti[pett] == undefined) {
                this.listaPreferiti[pett] = pett;
            } else {
                this.listaPreferiti[pett] = undefined;
            }
            console.log(pett + '-->' + this.listaPreferiti[pett]);
            helper.ls.set(
                'PREFERITI_' + this.$route.params.raceID,
                this.listaPreferiti
            );
            //this.togglePreferiti();
            //this.togglePreferiti();
            //this.showClassifica(this.raceData);
        },

    },
};
</script>

<style scoped>
td {
    height: 10px !important;
    _background-image: linear-gradient(60deg, grey, lightgray);
}

.frazioniTitle {
    text-align: center;
    background-color: lightgrey;
    border-radius: 0px 0px 3px 3px;
}

.frazioniValue {
    text-align: center;
    background-color: white;
    border-radius: 0px 0px 3px 3px;
    border-bottom: 1px solid lightgray;
}

.frazioniTitleFinale {
    text-align: center;
    background-color: red;
    color: white;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 0px 0px 5px 5px;
    _font-weight: bold;
}

.cardUp {
    background-color: #212121;
    color: white;
    _border: 1px solid lightgray;
    border-radius: 10px 0px 0px 10px;
}

.cardStatsHeader {
    background-color: #b71c1c !important;
    color: white;
    border-radius: 10px 10px 0px 0px;
}

.cardStats {
    background-color: white;
    color: black;
    border: 2px solid lightgray;
    border-radius: 10px 10px 10px 10px;
}

.boxed {
    border: 2px solid lightgray;
    border-radius: 10px 10px 10px 10px;
    margin-bottom: 20px;
}
</style>
